import { xButton, xButtonIcon } from "@xplus/components/button";
import { xBadge } from "@xplus/components/badge";
import { xDivider } from "@xplus/components/divider";
import { xAlert, xAlertRule } from "@xplus/components/alert";
import { xBreadcrumb, xBreadcrumbItem } from "@xplus/components/breadcrumb";
import { xIcon } from "@xplus/components/icon";
import { xCheckbox, xCheckboxGroup } from "@xplus/components/checkbox";
import { xDatePicker } from "@xplus/components/date-picker";
import {
  xDropdown,
  xDropdownItem,
  xDropdownOp,
} from "@xplus/components/dropdown";
import { xFilterGroup } from "@xplus/components/filter-group";
import { xForm, xFormItem } from "@xplus/components/form";
import { xImage } from "@xplus/components/image";
import { xInput, xInputAffix, xInputSearchMore } from "@xplus/components/input";
import {
  xSelect,
  xOption,
  xSelectMore,
  xSelectSingleTree,
  xSelectTree,
} from "@xplus/components/select";
import { xTree } from "@xplus/components/tree";
import { xPagination } from "@xplus/components/pagination";
import { xPopUp } from "@xplus/components/pop-up";
import { xPopover, xTableImage } from "@xplus/components/popover";
import { xProgress } from "@xplus/components/progress";
import { xRadio, xRadioButton, xRadioGroup } from "@xplus/components/radio";
import { xRate } from "@xplus/components/rate";
import { xSpace } from "@xplus/components/space";
import { xStep, xSteps } from "@xplus/components/steps";
import { xSwitch } from "@xplus/components/switch";
import { xTabs } from "@xplus/components/tabs";
import { xTag } from "@xplus/components/tag";
import { xTimeline, xTimelineItem } from "@xplus/components/timeline";
import { xTooltip, xTooltipIcon } from "@xplus/components/tooltip";
import { xTransfer } from "@xplus/components/transfer";
import {
  xVxeTable,
  xDragRowTable,
  xMergeColumnTable,
  xMergeRowTable,
} from "@xplus/components/table";
import {
  xInputComposeSelect,
  xSelectLikeInput,
  xSelectComposeDatePicker,
} from "@xplus/components/compose";
import { xText } from "@xplus/components/text";
import type { Plugin } from "vue";

export default [
  xButton,
  xButtonIcon,
  xBadge,
  xAlert,
  xAlertRule,
  xDivider,
  xBreadcrumb,
  xBreadcrumbItem,
  xIcon,
  xCheckbox,
  xCheckboxGroup,
  xDatePicker,
  xDropdown,
  xDropdownItem,
  xDropdownOp,
  xFilterGroup,
  xForm,
  xFormItem,
  xImage,
  xInput,
  xInputAffix,
  xInputSearchMore,
  xSelect,
  xOption,
  xSelectMore,
  xSelectTree,
  xSelectSingleTree,
  xTree,
  xPagination,
  xPopUp,
  xPopover,
  xTableImage,
  xProgress,
  xRadio,
  xRadioButton,
  xRadioGroup,
  xRate,
  xSpace,
  xStep,
  xSteps,
  xSwitch,
  xTabs,
  xTag,
  xTimeline,
  xTimelineItem,
  xTooltip,
  xTooltipIcon,
  xTransfer,
  xVxeTable,
  xDragRowTable,
  xMergeColumnTable,
  xMergeRowTable,
  xInputComposeSelect,
  xSelectLikeInput,
  xSelectComposeDatePicker,
  xText,
] as Plugin[];
